/**
 * MODAL/DIALOG TOKENS
 *
 * Custom additions are marked with "Custom" comments below.
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createModalTokens(s: SemanticTokens) {
  return {
    /** Base spacing for modals */
    base: {
      paddingX: v('modal.base.padding-x'), // --modal-base-padding-x: var(--spacing-24)
      paddingY: v('modal.base.padding-y'), // --modal-base-padding-y: var(--spacing-24)
      gap: v('modal.base.gap'), // --modal-base-gap: var(--spacing-24)
      radius: v('modal.base.radius'), // --modal-base-radius: var(--radius-16)
      width: '35rem',
    },
    dialogBg: s.surface.modal, // --modal-dialog-bg: var(--surface-modal)
    dialogHeaderBg: s.surface.modal, // --modal-dialog-header-bg: var(--surface-modal)
    dialogBorder: s.border.divider, // --modal-dialog-border: var(--border-divider)

    // ──── Custom tokens ────
    icon: {
      size: s.iconSizes.xl, // --modal-icon-size
    },
    header: {
      padding: s.layout.gap.lg, // --modal-header-padding: var(--spacing-24)
      gap: s.layout.gap.sm, // --modal-header-gap: var(--spacing-8)
      headerFg: s.text.secondary, // --modal-header-fg: var(--text-secondary)
    },
    fg: s.text.secondary, // --modal-fg: var(--text-secondary)
    shadow: s.shadow.lg, // --modal-shadow
    title: {
      fontSize: s.typography.fontSize.lg, // --modal-title-font-size
      fontWeight: s.typography.fontWeight.semibold, // --modal-title-font-weight
      lineHeight: '1.555', // --modal-title-line-height
    },
    closeBtn: {
      bg: s.surface.ground, // --modal-close-btn-bg: var(--surface-ground)
      fg: s.text.secondary, // --modal-close-btn-fg: var(--text-secondary)
      bgHover: 'transparent', // --modal-close-btn-bg-hover: transparent
      bgActive: 'transparent', // --modal-close-btn-bg-active: transparent
      bgDisabled: s.surface.disabled, // --modal-close-btn-bg-disabled
      fgDisabled: s.text.onColor, // --modal-close-btn-fg-disabled
      size: '1.25rem', // --modal-close-btn-size
      padding: s.layout.padding.xs, // --modal-close-btn-padding
      radius: s.radius.sm, // --modal-close-btn-radius
      fontWeight: s.typography.fontWeight.bold, // --modal-close-btn-font-weight
      fontSize: s.typography.fontSize.base, // --modal-close-btn-font-size
      iconSize: '0.875rem', // --modal-close-btn-icon-size
      transition: s.transition.fast, // --modal-close-btn-transition
    },
    content: {
      fontSize: s.typography.fontSize.base, // --modal-content-font-size
      lineHeight: '1.5', // --modal-content-line-height
      gap: s.layout.gap.md, // --modal-content-gap
    },
    footer: {
      gap: s.layout.gap.sm, // --modal-footer-gap
      fontWeight: s.typography.fontWeight.bold, // --modal-footer-font-weight
      fontSize: s.typography.fontSize.base, // --modal-footer-font-size
      lineHeight: '1.5', // --modal-footer-line-height
    },
    focusRing: s.focus.ring, // --modal-focus-ring: var(--border-focus)
    focusRingWidth: '2px', // --modal-focus-ring-width
    focusRingOffset: '2px', // --modal-focus-ring-offset
    overlayBg: v('surface.overlay-modal'), // --modal-overlay-bg
    statusIcon: {
      danger: s.text.danger, // --modal-status-icon-danger: var(--text-danger)
      success: s.text.success, // --modal-status-icon-success: var(--text-success)
      warning: s.text.warning, // --modal-status-icon-warning: var(--text-warning)
    },
  };
}
export const modalTokens = createModalTokens(SEMANTIC);
